// extracted by mini-css-extract-plugin
export default {"window":"lost_styles_window__QsTQr","text":"lost_styles_text__VkWBY"};